function isRefObject(ref) {
    return (typeof ref === "object" &&
        Object.prototype.hasOwnProperty.call(ref, "current"));
}

export { isRefObject };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/utils/is-ref-object.mjs
// module id = yj3F
// module chunks = 0